import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { useDashboardSearchParams as useSearchParams } from "@/hooks/useDashboardNavigation";
import { useOrgFromPathname } from "./useOrgFromPathname";

/**
 * Legacy hook that redirects ?support=open query param to the dedicated support page.
 * This hook should be used in the app layout to handle legacy URLs.
 */
export const useSupportDrawerRedirect = t0 => {
  const $ = _c(8);
  const enabled = t0 === undefined ? true : t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const orgFromPathname = useOrgFromPathname();
  let t1;
  if ($[0] !== enabled || $[1] !== searchParams) {
    t1 = enabled && searchParams.get("support") === "open";
    $[0] = enabled;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const shouldRedirect = t1;
  let t2;
  let t3;
  if ($[3] !== orgFromPathname || $[4] !== router || $[5] !== shouldRedirect) {
    t2 = () => {
      if (!shouldRedirect) {
        return;
      }
      router.replace(orgFromPathname ? `/${orgFromPathname}/support` : "/support");
    };
    t3 = [shouldRedirect, orgFromPathname, router];
    $[3] = orgFromPathname;
    $[4] = router;
    $[5] = shouldRedirect;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
};